import {IssuePickerFilteringServerQuery} from '@github-ui/server-persisted-queries'
import type {
  IssuePickerFilteringServerQueryQuery,
  IssuePickerFilteringServerQueryQueryVariables,
} from '@github-ui/server-persisted-queries/types/IssuePickerFilteringServerQuery'
import {reactFetchJSON} from '@github-ui/verified-fetch'

export type IssueFilteringQueryVariables = Omit<IssuePickerFilteringServerQueryQueryVariables, 'first'>

export function issueFilteringQueryKey(repositoryNameWithOwner: string, variables: IssueFilteringQueryVariables) {
  return ['item-picker', 'issue-filtering', repositoryNameWithOwner, variables] as const
}

export async function fetchIssueFiltering(
  repositoryNameWithOwner: string,
  variables: IssueFilteringQueryVariables,
  signal?: AbortSignal,
): Promise<IssuePickerFilteringServerQueryQuery> {
  const params = new URLSearchParams({
    queryId: IssuePickerFilteringServerQuery,
    commenters: variables.commenters,
    mentions: variables.mentions,
    assignee: variables.assignee,
    author: variables.author,
    other: variables.other,
    resource: variables.resource,
    query_is_url: String(variables.queryIsUrl),
    with_parent: String(variables.withParent),
    require_target_triage: String(variables.requireTargetTriage),
    semantically_similar_query: variables.semanticallySimilarQuery || '',
    include_semantically_similar: String(variables.includeSemanticallySimilar || false),
  })
  if (variables.semanticSearchType) params.set('semantic_search_type', variables.semanticSearchType)

  const response = await reactFetchJSON(`/${repositoryNameWithOwner}/issue_picker_filtering?${params.toString()}`, {
    signal,
  })
  if (!response.ok) throw new Error(`Issue picker filtering failed (${response.status})`)

  const json = (await response.json()) as {data?: IssuePickerFilteringServerQueryQuery; errors?: unknown[]}
  if (!json.data) throw new Error('Issue picker filtering query returned no data')

  return json.data
}
